// extracted by mini-css-extract-plugin
export var link = "styledLink-module--link--9PmIo";
export var text = "styledLink-module--text--NDPbN";